import React, {useEffect, useRef, useState} from 'react';
import CustomTable from '../../../components/customTable/CustomTable';
import {t,getLanguage} from 'react-switch-lang';
import {
  getAllRiskCategories,
  createRiskCategory,
  deleteRiskCategory,
  updateRiskCategory, deactivateRiskCategory,
} from '../../../services/riskCategoriesService';
import Toast from '../../../components/toast/Toast';
import Prompt from '../../../components/prompt/prompt';
import SearchBox from '../../../components/searchBox/SearchBox';
import AddIcon from './plus.png';
import './RiskCategories.scss';
import {validNameandNumberEngMneRegex} from '../../../utils/const';
import Swal from "sweetalert2";
const RiskCategories = () => {
  const [riskCategories, setRiskCategories] = useState([]);
  const [query, setQuery] = useState();

  const addButton = useRef();
  useEffect(() => {
    const fetchData = async () => {
      try {
        const {data} = await getAllRiskCategories();
        setRiskCategories(data);
      } catch (err) {}
    };
    fetchData();
  }, []);

  const columns = [
    {
      dataIndex: 'name',
      title: t('riskCategories.name'),
      editable: true,
      placeholder: t('riskCategories.placeholder.name'),
      rules: [
        {required: true, message: t('message.fieldRequired')},
        {
          pattern: validNameandNumberEngMneRegex,
          message: t('message.fieldNotValid'),
        },
        {min: 3, message: t('message.min', {min: 3})},
        {max: 255, message: t('message.max', {max: 255})},
        { whitespace: true,
          message: t('message.fieldNotValid'),
        },
      ],
    },
    {
      dataIndex: 'nameEn',
      title: t('riskCategories.nameEn'),
      editable: true,
      placeholder: t('riskCategories.placeholder.nameEn'),
      rules: [
        {required: true, message: t('message.fieldRequired')},
        {
          pattern: validNameandNumberEngMneRegex,
          message: t('message.fieldNotValid'),
        },
        {min: 3, message: t('message.min', {min: 3})},
        {max: 255, message: t('message.max', {max: 255})},
        { whitespace: true,
          message: t('message.fieldNotValid'),
        },
      ],
    },
  ];

  const onUpdate = async (data, editingRecord, form) => {
    data.id = editingRecord.id;
    data.nameEn = data.nameEn.trim();
    data.name = data.name.trim();
    data.active = editingRecord.active
    try {
      const response = await updateRiskCategory(data);
      if (response.status === 200) {
        Toast.fire({
          title: t('riskCategories.message.updateSuccess', {
            entity: t('riskCategories.riskCategory'),
          }),
          icon: 'success',
        });
      }
      return response;
    } catch (err) {
      if (err.response.data.detail === 'name') {
        form.setFields([
          {
            name: 'name',
            errors: [t('message.riskCategoryExists')],
          },
        ]);
      }
      if (err.response.data.detail === 'name_en') {
        form.setFields([
          {
            name: 'nameEn',
            errors: [t('message.riskCategoryExists')],
          },
        ]);
      }
    }
  };

  return (
    <div className="riskCategories administration-template">
      <div className="w-100 d-flex justify-content-between mb-4">
        <div className="search-field">
          <SearchBox
            placeholder={t('riskCategories.placeholder.search')}
            setQuery={setQuery}
          />
        </div>
      </div>
      <CustomTable
        api="/risk-categories"
        query={query}
        queryParamName="name.contains"
        sort={getLanguage() === "eng" ? "nameEn" : "name"}
        columns={columns}
        methods={{onUpdate}}
        addButtonRef={addButton}
        deactivateButton={true}
        actionsWidth={100}
        hideDeleteAndDeactivation={true}
      />
    </div>
  );
};

export default RiskCategories;
